import { RegularPresentLifeSupportPage } from "@/features/regular-document/pages/life-support-document/RegularPresentLifeSupport";
import React from "react";

const RegularPresentLifeSupport = () => {
  return <RegularPresentLifeSupportPage />;
};

export default RegularPresentLifeSupport;
